import { RoleMappingAccount } from "../../roles/requiredAccountsMapping";
import { addAccountInScope } from "../draftAccountOperations";
import { DraftState, GenerateId, replaceAccount } from "../draftState";

interface ApplyRoleAssignmentsParams {
    state: DraftState;
    workingAccounts: readonly RoleMappingAccount[];
    generateId: GenerateId;
}

// Working accounts whose id is not in the draft are rows created in the roles
// drawer; they become new draft rows. Draft rows absent from the working list
// keep their role.
export const applyRoleAssignments = ({
    state,
    workingAccounts,
    generateId,
}: ApplyRoleAssignmentsParams): DraftState => {
    const roleById = new Map(workingAccounts.map(({ id, role }) => [id, role]));
    const updatedAccounts = state.accounts.map((account) => {
        const role = roleById.get(account.id);
        return role === undefined || role === (account.role ?? null)
            ? account
            : { ...account, role };
    });
    const existingIds = new Set(state.accounts.map(({ id }) => id));

    return workingAccounts
        .filter(({ id }) => !existingIds.has(id))
        .reduce<DraftState>(
            (current, created) => {
                const added = addAccountInScope({
                    state: current,
                    entityId: 0,
                    type: created.type,
                    parentGroupId: null,
                    generateId,
                    codeText: created.codeText,
                });
                return {
                    ...added.state,
                    accounts: replaceAccount(
                        added.state.accounts,
                        added.accountId,
                        (account) => ({
                            ...account,
                            name: created.name,
                            role: created.role,
                        }),
                    ),
                };
            },
            { ...state, accounts: updatedAccounts },
        );
};
